import { Client, ClientModel } from "@services/api/types";

export interface IClientContext {
  client: Client;
  model: ClientModel;
}

export type ClientContextType = {
  currentClient: IClientContext;
  saveCurrentClient: (clientContext: IClientContext) => void;
};

export const DefaultClientContextType: ClientContextType = {
  currentClient: {
    client: {
      id: -1,
      name: "",
      email: "",
      phone: undefined,
      label: undefined,
      logo_path: "",
      base_color: "",
      kpi_label: "",
      currency: "",
      ui_modules: [],
      mmm_model_config: {
        metrics: []
      }
    },
    model: {
      id: -1,
      client_id: -1,
      name: "",
      year: -1,
      aggregation_type: "weekly"
    }
  },
  saveCurrentClient: (_: IClientContext) => {}
};
